import { render, staticRenderFns } from "./BrandSettingModel.vue?vue&type=template&id=0cecc493&scoped=true&"
import script from "./BrandSettingModel.vue?vue&type=script&lang=js&"
export * from "./BrandSettingModel.vue?vue&type=script&lang=js&"
import style0 from "./BrandSettingModel.vue?vue&type=style&index=0&id=0cecc493&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cecc493",
  null
  
)

export default component.exports